import colorAxis8Level from './colorAxis8Level'
const dataDisplayOptions = [
  {
    label: 'Public Indicators',
    options: [
      {
        value: 'data_value',
        tagKey: 'forecast_level',
        tagValue: 'data_value',
        label: 'Incidense Rate',
        colorAxis: colorAxis8Level,
        mapTitle: 'US RSV Incidence',
        mapSubTitle: undefined,
        indicatorName: 'Forecasts',
        legend: {
          enabled: false,
          title: {
            text: 'US RSV Incidence',
          },
        },
      },
    ],
  },
]

export default dataDisplayOptions
